module.exports = __webpack_public_path__ + "img/icon_arrow_next_black.4cb86062.png";